import axios from 'axios'
import store from '@/store/store'
import oh from 'object-hash'

const baseDomain = `${process.env.VUE_APP_SSY_API_HOST}:${process.env.VUE_APP_SSY_API_PORT}`
const baseUrl = `${baseDomain}` // In case of /api/v1

const CLIENT = axios.create({
  baseURL: baseUrl,
  headers: {
    'x-session-user-id'    : store.getters.sessionUser.id,
    'x-session-user-email' : store.getters.sessionUser.email,
    'x-session-super'      : store.getters.sessionUserPermissions.bSuperAdmin
  },
  // `transformResponse` allows changes to the response data to be made before
  // it is passed to then/catch
  transformResponse: [
    function (data) {
    // Do whatever you want to transform the data
      if (data) {
        try {
          const jsonData = JSON.parse(data)
          // Skip version mismatch reload in development env
          if (process.env.VUE_APP_ENV !== 'development' &&
            jsonData.clientsVersion &&
            jsonData.clientsVersion.dashboard !== process.env.VUE_APP_DASHBOARD_VERSION) {
            console.log(`Client version: ${process.env.VUE_APP_DASHBOARD_VERSION}`)
            window.location.reload(true)
          }
          return jsonData
        } catch (err) {
          return data
        }
      } else { // head on resource creation
        const formattedData = {
          status: 204,
          data: []
        }
        return formattedData
      }
    }
  ]
})

// REQUEST INTERCEPTOR, used for auditing
CLIENT.interceptors.request.use(config => {
  if (store.getters.sessionUser.id) {
    if (store.getters.uph !== oh({ id: store.getters.sessionUser.id, permissions: store.getters.sessionUserPermissions })) {
      throw new axios.Cancel('Invalid state. 403 Not Authorized.')
    } else if (store.getters.impersonation && !['get', 'post'].includes(config.method)) {
      throw new axios.Cancel('Invalid HTTP method. 403 Not Authorized.')
    }
  }
  if (!store.getters.sessionUser.id && window.location.href.indexOf('login') === -1 &&
    window.location.href.indexOf('new-password') === -1 &&
    window.location.href.indexOf('expedited-shipping') === -1 &&
    window.location.href.indexOf('mobile-yearbooks') === -1 &&
    window.location.href.indexOf('mfa') === -1) { // No user in session and not navigating to unauthed page
    window.location.href = `${window.location.origin}/login?redirect=${window.location.pathname}`
  }
  config.headers['x-session-user-id']    = store.getters.sessionUser.id
  config.headers['x-session-user-email'] = store.getters.sessionUser.email
  config.headers['x-session-super']      = store.getters.sessionUserPermissions.bSuperAdmin ||
    (store.getters.sessionUserImmediateAccounts && store.getters.sessionUserImmediateAccounts.length > 0 && store.getters.sessionUserImmediateAccounts[0].id === 'S00001')
  return config
}, (error) => {
  return Promise.reject(error)
})

export default CLIENT
